const state = {
  loading: 0,
  oss: 'https://oss.mcn-open.com/',
  userDrawerShow: false,
  servicepopupvisible: false,    // 服务弹窗
  servicepopupType: 1
}

const getters = {
  // 只要 loading > 0 就视为正在加载
  isLoading: (state) => state.loading > 0
}

const mutations = {
  setLoading(state, value) {
    state.loading = value
  },
  setUserDrawerShow(state, value) {
    state.userDrawerShow = value
  },
  setServicepopupvisible(state, value) {
    state.servicepopupvisible = value
  },
  setServicepopupType(state, value) {

    state.servicepopupType = value
  }
}

const actions = {
  showLoading({ commit, state }) {
    commit('setLoading', state.loading + 1)
  },
  hideLoading({ commit, state }) {
    const newValue = Math.max(state.loading - 1, 0) // 防止负数
    commit('setLoading', newValue)
  },
  setUserDrawerShow({ commit }, value) {
    commit('setUserDrawerShow', value)
  },
  setServicepopupvisible({ commit }, { visible, type = 1 }) {
    if(visible){
      commit('setServicepopupType', type)
      commit('setServicepopupvisible', visible)
    }else{
      commit('setServicepopupvisible', visible)
    }
  },
}

export default {
  namespaced: true,
  state,
  getters,
  mutations,
  actions
}
